import { Attachments } from '@westernmilling/eu_react_shared';

export default class EntityAttachments extends Attachments {
  constructor(props) {
    super(props);
    this.getData();
  }
}
